import ascending from "./ascending.js";
export default function least(values, compare) {
    if (compare === void 0) { compare = ascending; }
    var min;
    var defined = false;
    if (compare.length === 1) {
        var minValue = void 0;
        for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
            var element = values_1[_i];
            var value = compare(element);
            if (defined
                ? ascending(value, minValue) < 0
                : ascending(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    }
    else {
        for (var _a = 0, values_2 = values; _a < values_2.length; _a++) {
            var value = values_2[_a];
            if (defined
                ? compare(value, min) < 0
                : compare(value, value) === 0) {
                min = value;
                defined = true;
            }
        }
    }
    return min;
}
